import type { HTMLAttributes, ReactNode } from 'react'
import { AlertTriangle, CheckCircle2, LoaderCircle } from 'lucide-react'

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header">
    <div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{description && <p>{description}</p>}</div>
    {actions && <div className="header-actions">{actions}</div>}
  </header>
}

export function Panel({ children, className = '', ...props }: HTMLAttributes<HTMLElement>) {
  return <section {...props} className={`panel ${className}`}>{children}</section>
}

export function Metric({ label, value, note, tone = '' }: { label: string; value: ReactNode; note?: string; tone?: string }) {
  return <div className={`metric-card ${tone}`}><span>{label}</span><strong>{value}</strong>{note && <small>{note}</small>}</div>
}

export function Badge({ children, tone = 'neutral' }: { children: ReactNode; tone?: string }) {
  return <span className={`badge ${tone}`}>{children}</span>
}

export function Loading({ label = 'Caricamento…' }: { label?: string }) {
  return <div className="state-box" role="status" aria-live="polite">
    <LoaderCircle className="spin" aria-hidden="true" /><strong>{label}</strong>
  </div>
}

export function ErrorState({ message }: { message: string }) {
  return <div className="state-box error" role="alert">
    <AlertTriangle aria-hidden="true" /><strong>Qualcosa non torna</strong><p>{message}</p>
  </div>
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return <div className="state-box">
    <CheckCircle2 aria-hidden="true" /><strong>{title}</strong>{children && <p>{children}</p>}
  </div>
}

export function Button({ children, variant = 'primary', className = '', type = 'button', ...props }: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: string }) {
  return <button {...props} type={type} className={`button ${variant} ${className}`}>{children}</button>
}

export function Hash({ value }: { value?: string | null }) {
  if (!value) return <code className="hash muted" title="Identificativo non disponibile">—</code>
  return <code className="hash" title={value}>{value.slice(0, 10)}</code>
}
